export const MakerPage = 'MakerPage'
export const ScreenPage = 'ScreenPage'
export const AdminScreenPage = 'AdminScreenPage'
export const ProjectPage = 'ProjectPage'
export const LivePage = 'LivePage'
